import { Injectable } from '@angular/core';
import { JWT } from '../../models/jwt';

@Injectable({
  providedIn: 'root'
})
export class JwtUtilsService {
  /**
   * In Typescript, the enum is compiled into an object on the global scope, for which obj[obj[key]=value]=key (a value becomes also a key and a key also a value).
   * The current method only looks for number values, that can be separated from the enum's original keys that are always strings
   *
   * @param token: The type of the enum for which we retrieve the values
   */
  parseJwt(token: string): JWT {

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload) as JWT;
  }
}
